import React, {useEffect, useRef} from "react";
import {Network} from "@capacitor/network";
import {useAuthStore} from "../../redux/auth";
import {useCustomerStore} from "../../redux/customers";
import {useSystemStore} from "../../redux/system";

interface NetworkCheckerProps {}

const NetworkChecker: React.FC<NetworkCheckerProps> = () => {
    const customerStore = useCustomerStore();
    const { getAll } = customerStore;
    const systemStore = useSystemStore();
    const { setIsOnline } = systemStore;
    const authStore = useAuthStore();
    const { isAuthed } = authStore;

    // Refs so the once-registered listener reads current values instead of
    // the ones captured at registration (same pattern as PushListener).
    const getAllRef = useRef(getAll);
    const setIsOnlineRef = useRef(setIsOnline);
    const isAuthedRef = useRef(isAuthed);

    useEffect(() => {
        getAllRef.current = getAll;
    }, [getAll]);

    useEffect(() => {
        setIsOnlineRef.current = setIsOnline;
    }, [setIsOnline]);

    useEffect(() => {
        isAuthedRef.current = isAuthed;
    }, [isAuthed]);

    useEffect(() => {
        const handleNetworkChange = (status: { connected: boolean }) => {
            setIsOnlineRef.current({isOnline: status.connected});
            // NetworkChecker also mounts for guests (public storefront);
            // an authed GET /customers there would 401 → auto-logout.
            if (status.connected && isAuthedRef.current) {
                getAllRef.current().catch(() => { /** Handled by state and toast */ });
            }
        };

        const listenerHandle = Network.addListener("networkStatusChange", handleNetworkChange);

        Network.getStatus().then((status) => {
            setIsOnlineRef.current({isOnline: status.connected});
        });

        return () => {
            listenerHandle.then((handle) => handle.remove());
        };
    }, []);

    return null;
};

export default NetworkChecker;
